import React from 'react';
import { Link } from 'react-router-dom';
import ArrowLeft from '../_styles/images/ArrowLeft.png';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import Loading from '../shared/loading/Loading';
import * as actionTypes from '../redux/actionTypes';
import { Vanpooler } from '../join-commute/onboarding/vanpooler/Vanpooler';
import ParticipantDetailsPopup from './ParticipantDetailsPopup';
import analyticsService from '../shared/analytics/analytics-service';
import { RestrictTo } from '../shared/permissions/RestrictTo';
import {
  PERMISSION_COORDINATOR
} from '../shared/permissions/permissions';
import useError from '../shared/components/error-screen/useError';
import CommonToast from '../shared/components/common-toast-message/CommonToast';

function RosterView(props) {
  const [loading, updateLoading] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState([]);
  const [showPDPopup, updateShowPDPopup] = useState(false);
  const [vanpoolId, updateVanpoolId] = useState(null);
  const [toastOpen, updateToastOpen] = useState(false);
  const [toastData, updateToastData] = useState({message: '',type: 'success'});

  useEffect(() => {
    if (!props.loaded) {
      updateLoading(true);
      props.init();
      if(!props.profile.isLoaded){
        props.loadProfile();
      }
    }
  }, []);

  useError(props.loadError, props.history, props.loadErrorString);

  useEffect(() => {
    if (props.loaded) {
      updateLoading(false);
      setParticipants(props.roster.rosterParticipants);
      updateVanpoolId(props.roster.vanpoolId)
    }
    if (props.participantRoleUpdated && props.loaded) {
      updateToastOpen(true);
      updateToastData({message: 'Request Updated Successfully',type: 'success'});
      props.saveParticipantRoleUpdated();
    }
  }, [props.loaded, props.participantRoleUpdated]);


  function showParticipantDetails(participant) {
      setSelectedParticipant(participant);
       const roles = Object.keys(participant.roles).filter(key=>participant.roles[key]);
       analyticsService.modelOpened("vanpool/roster/view profile", roles.length? roles.join(":") : "");
      updateShowPDPopup(true)
  }

  function closeParticipantPopup() {
    updateShowPDPopup(false);
    setTimeout(function(){ 
      document.querySelector(".vanpooler-container").focus();
    },0)
  }

  return (
    <div className="roster-page">
      <Loading isLoading={loading} />
      <div className="container">
        <div className="header">
          <div className="backArrow">
            <div className="overview-link" onClick={props.history.goBack}>
              <img alt="go back" src={ArrowLeft} tabIndex={0} role='button'/>
            </div>
          </div>
          <div className="heading">Roster</div>
        </div>
        <div className="main" role="group">
          <div className={`participants-container ${ participants && participants.length <=4 ? "less" : ""}`}>
            {participants &&
              participants.map(participant => (
                <Vanpooler
                  key={participant.participantId}
                  participant={participant}
                  showParticipantDetails={(p) => showParticipantDetails(p)}
                  fromRoster={true}
                  isSubscription={props.isSubscription}
                />
              ))}
          </div>

        </div>
        {   
            !props.isSubscription ?
                <RestrictTo roles={[ PERMISSION_COORDINATOR ]} required={false} >
                  <div className='sticky-footer'>
                    <button className='button invite-vanpool-button' 
                    onClick={() => { 
                      analyticsService.analyticsProcessEvent({
                                "event": "click_generic",
                                "context": {
                                    "event_action": "invite to vanpool"
                                }
                      });
                      props.history.push('/vanpool/roster/invite-to-vanpool')}}>invite to vanpool</button>
                  </div>
               </RestrictTo> 
          : 
          null
        }
      </div>
      {
          showPDPopup && <ParticipantDetailsPopup close={closeParticipantPopup} participant={selectedParticipant} atMaxTripRecorders={props.roster.atMaxTripRecorders}  maxTripRecordersAllowed={props.roster.maxTripRecordersAllowed} save={props.save} updateLoading={ () => updateLoading(true)} delete={props.delete} vanpoolId={vanpoolId} />
      }
       <CommonToast message={toastData.message} type={toastData.type} isOpen={toastOpen} closeToast={() => updateToastOpen(false)} timeOut={6000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    roster: state.roster,
    loaded: state.roster.loaded,
    loadError: state.roster.loadError,
    loadErrorString: state.roster.loadErrorString,
    isSubscription: state.userAuth.isSubscription,
    participantRoleUpdated: state.roster.participantRoleUpdated,
    profile: state.profile
  };
}

function mapDispatchToProps(dispatch) {
  return {
    init() {
      dispatch({ type: actionTypes.ROSTER_LOADING });
    },
    save(data) {
      dispatch({ type: actionTypes.PARTICIPANT_ROLES_SAVING, data });
    },
    delete(id) {
      dispatch({ type: actionTypes.PARTICIPANT_PROFILE_DELETING, data: id });
    },
    saveParticipantRoleUpdated() {
      dispatch({ type: actionTypes.PARTICIPANT_ROLE_UPDATE_SUCCESS, data: false });
    },
    loadProfile() {
      dispatch({ type: actionTypes.USER_PROFILE_LOADING, notFromProfile:true, loadParticipants: true  });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RosterView);
